var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.products,"fixed-header":false,"search-options":{
      enabled: true,
      placeholder: 'Otsi tooteid',
    },"pagination-options":{
      enabled: true,
      position: 'top',
      perPage: 25,
      perPageDropdown: [50, 100],
      dropdownAllowAll: true,
      nextLabel: 'Järgmised',
      prevLabel: 'Eelmised',
      rowsPerPageLabel: 'Tooteid leheküljel',
      ofLabel: '/',
      allLabel: 'Kõik',
    },"sort-options":{
      enabled: true,
      initialSortBy: { field: 'timestamp', type: 'desc' },
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'shortcode')?_c('span',[_c('a',{attrs:{"href":("https://instagram.com/p/" + (props.row.shortcode)),"target":"_blank"}},[_vm._v("Postitus")])]):_c('span',[_vm._v(" "+_vm._s(props.formattedRow[props.column.field])+" ")])]}}])},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[(_vm.products.length !== 0)?_c('p',[_vm._v("Ei leidnud ühtegi toodet.")]):_c('div',{attrs:{"id":"loadingwrapper"}},[_c('span',{attrs:{"id":"loadingicon"}},[_vm._v("🥦")])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }